module.exports = __webpack_public_path__ + "img/b3.d82b4ccd.jpg";